import { Button, Chip, Div, Label, useWindowSize, Loader } from "@grassrootly/rn-core";
import { Image } from "react-native";
import { images } from "../../../layout/assets";
import { GameTeams } from "../lib";
import { EditGameLineupsProps, useEditGameLineups } from "./useEditGameLineups";
import { IGameAttendances } from "@grassrootly/api";

export default function EditGameLineups(params: EditGameLineupsProps) {
  const { isMobile } = useWindowSize();
  const {
    attendingPlayers,
    updateTeamAssignment,
    isInTeam,
    unsavedChanges,
    saveChanges,
    clearChanges,
    isUpdating,
  } = useEditGameLineups(params);

  return (
    <Div classNames={["flex1", "bgNeutralDarkerDark"]}>
      {/* Header with team distribution stats */}
      <Div classNames={["flexRow", "mb-{16}", "alignItemsCenter", "justifyContentSpaceBetween", "ph8", "pt-{16}", "bgNeutralDarkerDark"]}>
        <Div classNames={["flexRow", "alignItemsCenter"]}>
          <Label type="l3Regular" classNames={["mr-{5}"]}>
            {params.game?.host_team_name || GameTeams.hosts.label}:
          </Label>
          <Label type="l3Bold" classNames={["mr-{15}", "colorPrimaryMain"]}>
            {attendingPlayers.filter((a: IGameAttendances) => a.team === GameTeams.hosts.key).length}
          </Label>
          <Label type="l3Regular" classNames={["mr-{5}"]}>
            {params.game?.visitor_team_name || GameTeams.visitors.label}:
          </Label>
          <Label type="l3Bold" classNames={["colorPrimaryMain"]}>
            {attendingPlayers.filter((a: IGameAttendances) => a.team === GameTeams.visitors.key).length}
          </Label>
        </Div>
      </Div>

      {/* Attending players list with team assignment */}
      <Div classNames={["flex1", "ph8", "bgNeutralDarkerDark"]}>
          {attendingPlayers.length === 0 ? (
            <Div classNames={["alignItemsCenter", "mt-{30}"]}>
              <Label type="l3Regular" classNames={["textCenter", "colorSecondaryLight"]}>
                No players are attending this training session.
              </Label>
              <Label type="l4Regular" classNames={["textCenter", "colorSecondaryLight", "mt-{8}"]}>
                Go to the Attendees tab to mark players as attending.
              </Label>
            </Div>
          ) : (
            attendingPlayers.map((attendee: IGameAttendances, index: number) => (
              <Div
                key={index}
                classNames={[
                  "p16",
                  "mb-{8}",
                  index % 2 == 0 ? "bgNeutralDarkerMain" : "bgSecondaryMain",
                  "flexRow",
                  "alignItemsCenter",
                ]}
              >
                <Div classNames={isMobile ? ["flexColumn", "w100"] : ["flexRow", "w100"]}>
                  <Div classNames={["flexRow", "alignItemsCenter", !isMobile ? "w50" : "w100"]}>
                    <Image
                      style={{ height: 40, width: 40, borderRadius: 40 }}
                      resizeMode="cover"
                      source={
                        attendee.player?.profile_picture ? { uri: attendee.player?.profile_picture } : images.playerAvatar
                      }
                    />
                    <Label classNames={["pl-{5}"]}>{attendee.player?.name}</Label>
                  </Div>
                  <Div
                    classNames={[
                      "flexRow",
                      !isMobile ? "w50" : "w100",
                      "justifyContentFlexEnd",
                      "alignItemsCenter",
                      isMobile ? "mt-{-5}" : "",
                    ]}
                  >
                    <Div classNames={["dInlineFlex", "flexRow", "alignItemsCenter", "gap8"]}>
                      {isUpdating(attendee.player_id) ? (
                        <Div classNames={[
                          "alignItemsCenter", 
                          "justifyContentCenter", 
                          "p8", 
                          "bgNeutralDarkerContrast", 
                          "rounded",
                          "minW-{80}",
                          "minH-{32}"
                        ]}>
                          <Loader size={16} />
                        </Div>
                      ) : (
                        <>
                          <Chip
                            title={params.game?.host_team_name || GameTeams.hosts.label}
                            type={"tag"}
                            onPress={() => updateTeamAssignment(attendee, GameTeams.hosts.key)}
                            classNames={[
                              "l4Regular", 
                              isInTeam(attendee, GameTeams.hosts.key) === 1 
                                ? "bgPrimaryMain" 
                                : "bgNeutralDarkerContrast",
                              isInTeam(attendee, GameTeams.hosts.key) === 1 
                                ? "colorNeutralLighterLight" 
                                : "colorSecondaryContrast"
                            ]}
                          ></Chip>
                          <Chip
                            title={params.game?.visitor_team_name || GameTeams.visitors.label}
                            type={"tag"}
                            onPress={() => updateTeamAssignment(attendee, GameTeams.visitors.key)}
                            classNames={[
                              "l4Regular",
                              isInTeam(attendee, GameTeams.visitors.key) === 1 
                                ? "bgPrimaryMain" 
                                : "bgNeutralDarkerContrast",
                              isInTeam(attendee, GameTeams.visitors.key) === 1 
                                ? "colorNeutralLighterLight" 
                                : "colorSecondaryContrast"
                            ]}
                          ></Chip>
                        </>
                      )}
                    </Div>
                  </Div>
                </Div>
              </Div>
            ))
          )}
        </Div>
    </Div>
  );
}
